module.exports = __webpack_public_path__ + "img/content6-8.35a48e89.webp";